import * as React from "react";
import { useEffect } from "react";
import {
  DataResult,
  State,
  translateDataSourceResultGroups,
} from "@progress/kendo-data-query";
import axios from "axios";
import { getBranchesRequest } from "./GetBranchesRequest";

interface GridDataLoaderProps {
  readonly url: string;
  readonly dataState: State;
  readonly onDataReceived: (dataResult: DataResult) => void;
  readonly httpMethod?: "GET" | "POST";
  readonly rateAgreementId?: string;
}

export function GridDataLoaderCutOffNextTry({
  url,
  dataState,
  onDataReceived,
  httpMethod,
  rateAgreementId,
}: GridDataLoaderProps) {
  const lastSuccess = React.useRef<string>("");
  const pending = React.useRef<string>("");

  const urlForCutOff = "sort=&group=&filter=";

  const requestDataIfNeeded = async () => {
    if (pending.current) {
      return;
    }

    const { group } = dataState;
    const hasGroups = group && group.length;

    pending.current = urlForCutOff;
    const { bidpacks } = await getBranchesRequest(rateAgreementId);
    axios
      .request({
        method: httpMethod,
        url: `${url}?${pending.current}`,
      })
      .then((response) => response.data)
      .then((x) => {
        lastSuccess.current = pending.current;
        pending.current = "success";
        if (urlForCutOff === lastSuccess.current) {
          let data = hasGroups
            ? translateDataSourceResultGroups(x.Data)
            : x.Data;

          data = data.map((d: any) => {
            return {
              ...d,
              DestinationName:
                bidpacks?.find((x) => x.BidPackID === d.BidPackID)
                  ?.DestinationName ?? undefined,
            };
          });
          onDataReceived.call(undefined, {
            data,
            total: x.Total,
          });
        } else {
          requestDataIfNeeded();
        }
      });
  };

  useEffect(() => {
    requestDataIfNeeded();
  });

  // return pending.current ? <LoadingPanel /> : null;
  return null;
}
